import { Component, Input } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { StoreService } from './store.service';

type AOA = Array<Array<any>>;

function s2ab(s: string): ArrayBuffer {
	const buf: ArrayBuffer = new ArrayBuffer(s.length);
	const view: Uint8Array = new Uint8Array(buf);
	for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}


@Component({
	selector: 'sheetjs',
	template: `
	<div>
	<span class="button_cont">
	<button *ngIf="$store.router.profile" class="modeButton" 
	(click)="exportData()" mat-fab>
	 <mat-icon matTooltip="Export Excel" aria-label="Export">insert_drive_file</mat-icon>
   </button>
   <button *ngIf="!$store.router.profile" class="modeButton modeButton_DisplayPage" 
   (click)="exportData()" mat-fab>
	<mat-icon matTooltip="Export Excel" aria-label="Export">insert_drive_file</mat-icon>
  </button>
   </span>
   <span *ngIf="$store.router.profile">
   <span *ngIf="$store.editModeGlobal">
   <span *ngIf="!this.$store.editMode" class="button_cont">
   <button class="modeButton" 
	(click)="changeMode()" mat-fab>
	 <mat-icon matTooltip="Edit mode" aria-label="Edit mode">edit</mat-icon>
   </button>
   </span>
   <span *ngIf="this.$store.editMode" class="button_cont">
   <button class="modeButton" 
   (click)="changeMode()" mat-fab>
	   <mat-icon matTooltip="View mode" aria-label="View mode">remove_red_eye</mat-icon>
   </button>
   </span>
   </span>
   </span>
   <div>
	`,
	styleUrls: ['./sheetjs.component.css']
})


export class SheetJSComponent {

	@Input() profile : any; 
	constructor(
		private $store: StoreService,
	  ) { }
	
	  
	customClassExpButton = "modeButton "

	data: AOA = [];
	wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'binary' };
	fileName: string = 'SheetJS.xlsx';

	  dataUser = []
	  dataExpertise = []
	  dataTool = []
	  dataLanguage = []
	  dataItlanguage = []
	  header = [['Compétence', 'Niveau', 'Certification', 'Likes']]
	  titreExpertise = [['', '', ''], ['', '', ''], ['Expertise', '', ''], ['', '', '']]
	  titreTool = [['', '', ''], ['', '', ''], ['Outils', '', ''], ['', '', '']]
	  titreLanguage = [['', '', ''], ['', '', ''], ['Langues', '', ''], ['', '', '']]
	  titreItlanguage = [['', '', ''], ['', '', ''], ['Langages informatiques', '', ''], ['', '', '']]

	

	exportData() {
		this.profile ? this.exportDataProfile() : this.exportDataSearch()
	}

	exportDataProfile() {

		var array = [['Nom', 'Prénom', 'Email', 'Grade', 'Domaine', 'Compétence', 'Niveau', 'Certification', 'Likes']]
		let u = this.$store.profile
				var splittedName = u.displayName.split(' ')
				var name = splittedName.pop()
				var foo = ''
				var firstName = splittedName.forEach(
					el => foo = foo + el + ' '
				)
				firstName = foo
				var userInfos = [
					name, 
					firstName, 
					u.email,
					''
				]
				u.skills.forEach(
					s => {
						var userSkill = [
							s.type, 
							s.skillName, 
							s.level,
							s.certified ? 'Oui' : '', 
							s.likes.length
						]
						array.push(userInfos.concat(userSkill))
					}
			)
			this.export(array)

	}


	exportDataSearch() {
		var array = [['Nom', 'Prénom', 'Email', 'Grade', 'Domaine', 'Compétence', 'Niveau', 'Certification', 'Likes']]
		this.$store.filteredUsers.forEach(
			u => {
				var splittedName = u.displayName.split(' ')
				var name = splittedName.pop()
				var foo = ''
				var firstName = splittedName.forEach(
					el => foo = foo + el + ' '
				)
				firstName = foo
				var userInfos = [
					name, 
					firstName, 
					u.email,
					''
				]
				u.filteredSkills[0] ? (u.filteredSkills) : 
				(u.filteredSkills = u.skills)
				u.filteredSkills.forEach(
					s => {
						var userSkill = [
							s.type, 
							s.skillName, 
							s.level,
							s.certified ? 'Oui' : '', 
							s.likes.length
						]
						array.push(userInfos.concat(userSkill))
					}
			)})
			this.export(array)
		}
	

	onFileChange(evt: any) {
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];

			/* save data */
			this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
		};
		reader.readAsBinaryString(target.files[0]);
	}

	export(data): void {
		/* generate worksheet */
		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

		/* generate workbook and add the worksheet */
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		/* save to file */
		const wbout: string = XLSX.write(wb, this.wopts);
		saveAs(new Blob([s2ab(wbout)]), this.fileName);
	}


	changeMode() {
		this.$store.editMode = !this.$store.editMode
	  }

}


// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/sheetjs.component.ts